import {Menu, Transition} from "@headlessui/react"
import React, {Fragment} from "react"
import {Language} from "../../views/types";

interface IProps {
    language: Language,
    onChange: (language: Language) => void
}

export default function LanguageForm(props: IProps) {
    const data = [
        {title: "English", type: Language.en, value: "ENG"},
        {title: "Español", type: Language.sp, value: "ESP"},
        {title: "中文", type: Language.zh, value: "中文"},
    ]
    const tItem = data.find((item) => {
        return item.type === props.language
    })

    return (
        <div className="w-max">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Menu.Button className="inline-flex w-full justify-center rounded-md px-4 py-2 text-base text-white font-bold focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                        {tItem ? tItem.value : "ENG"}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute right-0 mt-2 w-40 p-2 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => {
                                        props.onChange(Language.en)
                                    }}
                                    className={`${
                                        active ? "bg-[#365496] text-white" : "text-gray-900"
                                    } group flex w-full items-center rounded-md px-2 py-2 text-base`}
                                >
                                    English
                                </button>
                            )}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => {
                                        props.onChange(Language.zh)
                                    }}
                                    className={`${
                                        active ? "bg-[#365496] text-white" : "text-gray-900"
                                    } group flex w-full items-center rounded-md px-2 py-2 text-base`}
                                >
                                    中文
                                </button>
                            )}
                        </Menu.Item>
                        <Menu.Item>
                            {({ active }) => (
                                <button
                                    onClick={() => {
                                        props.onChange(Language.sp)
                                    }}
                                    className={`${
                                        active ? "bg-[#365496] text-white" : "text-gray-900"
                                    } group flex w-full items-center rounded-md px-2 py-2 text-base`}
                                >
                                    Español
                                </button>
                            )}
                        </Menu.Item>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}
